export default __webpack_public_path__ + "static/media/click-game-menu-147356.8a6597e0.mp3";